export default __webpack_public_path__ + "static/media/icon_search.c39ea587.svg";